import React from 'react';
import { useTranslation } from 'react-i18next';

const Statistics = () => {
  const { t } = useTranslation();

  const stats = [
    {
      number: '11+',
      label: 'Active Partners',
      key: 'Active Partners'
    },
    {
      number: '15+',
      label: 'Years Experience',
      key: 'Years Experience'
    },
    {
      number: '50K+',
      label: 'Lives Impacted',
      key: 'Lives Impacted'
    },
    {
      number: '100%',
      label: 'Commitment',
      key: 'Commitment'
    }
  ];

  return (
    <div className="statistics-section py-20 bg-red" style={{ minHeight: '200px' }}>
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl md:text-6xl font-bold text-white mb-4">
                {stat.number}
              </div>
              <div className="text-white text-base md:text-lg font-medium uppercase tracking-wide">
                {t(stat.key)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Statistics;